module.exports = __webpack_public_path__ + "static/media/No data-bro.c10078fc.svg";